import { ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';
import { getComboBoxStyles } from './ComboBox.styles';
import { getCommandBarStyles } from './CommandBar.styles';
import { getDialogStyles } from './Dialog.styles';
import { getDropdownStyles } from './Dropdown.styles';
import { getNavStyles } from './Nav.styles';
import { getPanelStyles } from './Panel.styles';
import { getPrimaryButtonStyles } from './PrimaryButton.styles';

/* 
    Constructs a strongly typed theme override object for each 
    custom-styled Fluent Component.  If styling a new component, 
    add a ComponentName.styles.ts file in the ComponentStyles/ folder.
*/
export const getCustomComponentStyles = (
    themeSetting: Theme,
    theme: ITheme
) => ({
    PrimaryButton: {
        styles: getPrimaryButtonStyles(themeSetting, theme)
    },
    Nav: {
        styles: getNavStyles(themeSetting, theme)
    },
    CommandBar: {
        styles: getCommandBarStyles(themeSetting, theme)
    },
    Panel: {
        styles: getPanelStyles(themeSetting, theme)
    },
    Dialog: {
        styles: getDialogStyles(themeSetting, theme)
    },
    Dropdown: {
        styles: getDropdownStyles(themeSetting, theme)
    },
    ComboBox: {
        styles: getComboBoxStyles(themeSetting, theme)
    }
});
